import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRightDown20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.75 14.6893V6.5H17.25V17.25L6.5 17.25L6.5 15.75H14.6894L2.46973 3.53033L3.53039 2.46967L15.75 14.6893Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRightDown20.displayName = 'ArrowRightDown20';
export default ArrowRightDown20;
